import React from 'react';
import MiCompAPI from '../../../util/api';
import {
  Form, Row, Col, Input, Select, Button, Icon, message, Spin
} from 'antd';
import TableWrapper from '../../elements/TableWrapper';


const { Option } = Select;

class EAD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.niperexternal({ ...values, rtype: values.etype });
      }
    });
  }
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, States: [], niprfeerequest: null,
      disablelicence: false, disablednr_state: false, niprEligibilityform: null
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
    this.columes = [
      {
        title: 'LOA',
        render: (text, record) => record && record.name
      },
      {
        title: 'License',
        render: (text, record) => record && record.classDescription
      },
      {
        title: 'State Fee',
        render: (text, record) => "$" + record && record.fee.stateFee
      },
      {
        title: 'State Late Fee',
        render: (text, record) => "$" + record && record.fee.stateLateFee

      },
      {
        title: 'State Other Fees',
        render: (text, record) => "$" + record && record.fee.stateOtherFees
      },
      {
        title: 'Processing Fee',
        render: (text, record) => "$" + record && record.fee.processingFee
      },
      {
        title: 'Transaction Fee',
        render: (text, record) => "$" + record && record.fee.transactionFee
      },
      {
        title: 'Total Fees',
        render: (text, record) => "$" + record && record.fee.totalFees
      }, {
        title: "Action",
        render: (text, record) => <Button type="primary" onClick={() => {
          this.props.history.push({
            pathname: "/mynipr",
            state: { ...this.state.niprEligibilityform, record }
          })
        }}>Apply</Button>,

      }
    ];
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            States: data.states,

          });
        }
      },
      ["STATE"]
    );
  }
  componentDidMount = () => {
    this.getClientMasters();
  }
  niperexternal = (value) => {
    this.setState({
      isloding: true
    })
    this.api.invoke(
      "NIPR_External",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              niprEligibilityform: value,
              niprfeerequest: data.data,
              isloding: false,
            })

          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }, value
    );
  }
  onChange = (e) => {
    this.setState({
      disablednr_state: false,
      disablelicence: false
    });
    if (e === "RL") {
      this.setState({
        disablednr_state: true,
        disablelicence: true
      });

    } else if (e === "NRLNHS" || e === "NRALNHS") {
      this.setState({
        disablelicence: true
      });
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_main_div">
        <Row>
          <Col sm={24} md={8}>
            <p className="mi_title" style={{ marginLeft: '10px' }}>
              Eligibility  and Fee Request              </p>
          </Col></Row>
        <div className="mi_main" style={{ marginTop: '10px' }}>
          {this.state.isloding ?
            <div style={{ textAlign: 'center', display: 'absolute' }}>
              <Spin size="large" />
            </div>
            : ""}
          <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark >
            <Row>
              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Eligibility </legend>
                    {getFieldDecorator('etype', {
                      rules: [{ required: true, message: 'Please Select Eligibility' }, {

                      }],
                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                      optionFilterProp="children"
                      showSearch={true}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={this.onChange}
                      placeholder="Please Select Eligibility "
                    ><Option value="NRL" >NRL</Option>
                      <Option value="RL" >RL</Option>
                      {/* <Option value="NRAL" >NRAL</Option>
                        <Option value="NRLNHS" >NRLNHS</Option>
                        <Option value="NRALNHS" >NRALNHS</Option> */}
                    </Select>)}
                  </fieldset>
                </Form.Item>
              </Col>

              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Last Name</legend>
                    {getFieldDecorator('lname', {
                      rules: [{ required: true, message: 'Please enter Last Name' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "It allows only Alphabets,No whitespace at the beginning and end"
                      }],
                    })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder="Last Name" />)}
                  </fieldset>
                </Form.Item>
              </Col>
              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">SSN</legend>
                    {getFieldDecorator('ssn', {
                      rules: [{ required: true, message: 'Please enter ssn' },
                      { max: 9, message: "SSN is  must be atleast 9 characters" },
                      { min: 9, message: "SSN is  must be atleast 9 characters" }]
                    })(
                      <Input type="text" maxLength={9} minLength={9} autoComplete={"nope"} className="ant-input mi_input" placeholder="Enter SSN" />

                    )}
                  </fieldset>
                </Form.Item>
              </Col>
              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Res State</legend>
                    {getFieldDecorator('res_state', {
                      rules: [{ required: true, message: 'Please enter res state' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                        message: "It allows only Alphanumerics _,/,#,-"
                      }],
                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                      optionFilterProp="children"
                      showSearch={true}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      placeholder="Please Select Res State ">
                      {this.state.States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                    </Select>)}
                  </fieldset>
                </Form.Item>
              </Col>

              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">NR State</legend>
                    {getFieldDecorator('nr_state', {
                      rules: [{ required: !this.state.disablednr_state, message: 'Please enter nr state' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                        message: "It allows only Alphanumerics _,/,#,-"
                      }],
                    })(<Select disabled={this.state.disablednr_state} suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                      optionFilterProp="children"
                      showSearch={true}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      placeholder="Please Select NR State ">
                      {this.state.States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                    </Select>)}
                  </fieldset>
                </Form.Item>
              </Col>
              <Col md={8} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">License Number</legend>
                    {getFieldDecorator('license_num', {
                      rules: [{ required: !this.state.disablelicence, message: 'Please enter license number' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s_,/,-]+$/,
                        message: "It allows only Alphanumerics _,/,#,-"
                      }],
                    })(<Input disabled={this.state.disablelicence} autoComplete={"nope"} className="mi_input" type="text" placeholder="Enter License Number" />)}
                  </fieldset>
                </Form.Item>
              </Col>

            </Row>
            <Row style={{ marginRight: "20px" }}>

              <Button className="mi_button_right" type="primary" htmlType="submit">
                Fee Request
              </Button>{" "}
              <Button className="mi_button_right submit-button"

                onClick={() => { this.props.history.push("/profile"); }}
              >
                Back
              </Button>
            </Row>
          </Form></div>
        {this.state.niprfeerequest ?
          <div className="mi_main_div" style={{ paddingLeft: "12px" }}>
            <TableWrapper rowKey="id"
              columns={this.columes}
              data={this.state.niprfeerequest}
            /></div> : null}
      </div>)
  }
}
const NiprEligibility = Form.create()(EAD);
export default NiprEligibility;